var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13C2 17.6717 4.80856 21.6632 8.77038 23.2581C9.37826 23.5028 10 23.0244 10 22.3691V22.2981C10 21.8676 9.72181 21.4908 9.32659 21.32C6.22535 19.9801 4 16.7962 4 13C4 7.96046 7.92179 4 12.6083 4C16.5833 4 20.0082 6.84927 20.9565 10.7896C20.9567 10.7904 20.9576 10.7909 20.9584 10.7905V10.7905C20.9592 10.7902 20.9601 10.7907 20.9603 10.7915C21.0185 11.0295 21.0675 11.2713 21.1069 11.5164C21.18 11.971 21.6762 12.2585 22.122 12.1433C22.4853 12.0495 22.8632 12 23.2493 12C25.8053 12 28 14.1696 28 17C28 19.8105 25.8359 21.9695 23.3029 21.9996V21.9996C23.1356 21.9998 23 22.1356 23 22.3029V23.7459C23 23.8851 23.1101 24 23.2493 24V24C26.9776 24 30 20.866 30 17C30 13.134 26.9776 10 23.2493 10V10C22.9999 10 22.7753 9.8404 22.7009 9.60242C21.3204 5.19007 17.3236 2 12.6083 2C6.74949 2 2 6.92487 2 13ZM18 17C17.5405 16.6936 16.9196 16.8178 16.6133 17.2773L13.168 22.4453L12.3388 23.6891C12.2502 23.822 12.3454 24 12.5052 24H14H16.6531C16.8162 24 16.9108 24.1848 16.8152 24.3171L14.4415 27.6038C14.1181 28.0516 14.2189 28.6766 14.6667 29V29C15.1144 29.3234 15.7395 29.2225 16.0628 28.7748L19.8107 23.5855L20.7267 22.3171C20.8223 22.1848 20.7278 22 20.5646 22H19H16.2422C16.0825 22 15.9872 21.822 16.0758 21.6891L18.2774 18.3868C18.5837 17.9272 18.4595 17.3064 18 17V17Z",
    fill: "#009BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstorm);
export default __webpack_public_path__ + "static/media/thunderstorm.5cd1bcadab9b9f1196760ab0255ff05a.svg";
export { ForwardRef as ReactComponent };